// extracted by mini-css-extract-plugin
module.exports = {"page":"xu-z","cartModal":"yu-z","checkout":"zu-z","placeholder":"Au-z","account":"Bu-z"};